module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25975891ecd8a6f4ef56f1ab478442cd.png";